import useTypedTranslation from '@/hooks/useTypedTranslation';
import { MetaEnum } from '@/types/translations/MetaEnum';
import Head from 'next/head';
import { ImagesAuthenticationResetPasswordWhiskyDecanterSecurityRenewalWebp } from '@/assets/images_authentication_reset-password.assets';
import { useRouter } from 'next/router';
import getCanonicalUrl from '@/utilites/seo/get-canonical-url';
import LanguageAlternates from '../LanguageAlternates';

export default function ForgotPasswordMeta() {
  const router = useRouter();
  const { translate } = useTypedTranslation<MetaEnum>('meta');
  const url = getCanonicalUrl(router);
  const image = `https://spiritory.com${ImagesAuthenticationResetPasswordWhiskyDecanterSecurityRenewalWebp.src}`;
  return (
    <Head>
      <title>
        {translate(MetaEnum['reset_password.reset_password_title'])}
      </title>

      <meta
        name="description"
        content={translate(
          MetaEnum['reset_password.reset_password_description']
        )}
      />

      <meta
        name="keywords"
        content={translate(MetaEnum['reset_password.reset_password_keywords'])}
      />

      <meta name="author" content="Spiritory GMBH" />

      <meta name="robots" content="noindex, nofollow" />

      <meta
        property="og:title"
        content={translate(
          MetaEnum['reset_password.reset_password_call_to_action']
        )}
      />
      <meta
        property="og:description"
        content={translate(
          MetaEnum['reset_password.reset_password_description']
        )}
      />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content={translate(MetaEnum['reset_password.reset_password_title'])}
      />
      <meta
        name="twitter:description"
        content={translate(
          MetaEnum['reset_password.reset_password_description']
        )}
      />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@spiritoryGlobal" />
      <meta name="twitter:creator" content="@spiritoryGlobal" />
      <meta name="referrer" content="no-referrer" />
      <link rel="canonical" href={url} />
      <LanguageAlternates />
    </Head>
  );
}
